var port = ''
if (location.protocol === 'http:') {
    // port = ':33006'
}
if (location.hostname.includes && location.hostname.includes('ngrok')) {
    port = ''
}

var socket = io.connect(location.protocol + '//' + location.host + port)
socket.on('reload-page', function (msg) {
    showError({
        header: i18next.t('custom.page-reload'),
        message: i18next.t('custom.page-reload-needed')
    })
    setTimeout(function () {
        window.location.reload()
    }, 30000)
})

// datepicker component initialize/format
jQuery.fn.bstooltip = jQuery.fn.tooltip
if (!$.fn.bootstrapDP && $.fn.datepicker && $.fn.datepicker.noConflict) {
    var datepicker = $.fn.datepicker.noConflict() // return $.fn.datepicker to previously assigned value
    $.fn.bootstrapDP = datepicker // give $().bootstrapDP the bootstrap-datepicker functionality
}

$(document).ready(function () {
    

    $(
        '.datepicker:not(.inline):not(.datepicker-pure):not(.month-picker)'
    ).bootstrapDP({
        format: 'yyyy-mm-dd',
        //startDate: new Date(),
        autoclose: true,
        //forceParse: false
    })
    $('.datepicker.inline').bootstrapDP({
        format: 'yyyy-mm-dd',
        startDate: new Date(),
    })
    $('.datepicker.datepicker-pure').bootstrapDP({
        format: 'yyyy-mm-dd',
        autoclose: true,
        todayHighlight: true,
    })

    $('.datepicker.month-picker').bootstrapDP({
        format: 'yyyy-mm',
        autoclose: true,
    })

    $('.datepicker.year-picker').bootstrapDP({
        format: 'yyyy',
        autoclose: true,
    })

    $('[data-toggle="tooltip"]').tooltip()

    $('nav .toggle-mobile-menu').on('click', function () {
        $(this).prev('.links').slideToggle(50)
    })

    $(window).resize(function () {
        if ($(document).width() > 767) {
            $('nav .links').show().css('display', 'flex')
        } else {
            $('nav .links').css('display', 'block').hide()
        }
    })

    // $('nav .login, header .let-go').on('click', function (e) {
    //     e.preventDefault()
    //     $('.modal.login').modal()
    // })

    // $('.modal.login .forgot-link').on('click', function (e) {
    //     e.preventDefault()
    //     $('.modal.login').modal('hide')
    //     $('.modal.forget-password').modal()
    // })
    // $('.modal.forget-password').on('hidden.bs.modal', function () {
    //     $('.modal.login').modal()
    // })

    // $('.modal.login #create-account').on('click', function (e) {
    //     e.preventDefault()
    //     $('.modal.login').modal('hide')
    //     $('.modal.register').modal()
    // })
    // $('.modal.register').on('hidden.bs.modal', function () {
    //     $('.modal.login').modal()
    // })
    // $('.modal.register #login').on('click', function (e) {
    //     e.preventDefault()
    //     $('.modal.register').modal('hide')
    //     $('.modal.login').modal()
    // })
})
